import { TaskParameterModel } from "@/components/task-parameter/models";
import { ResponseModel } from "@/models";
import { ITaskParameters } from "../ITaskParameters";
import ApiService from "@/api";
import { SendErrorNotification } from "../functions";
import UpdateProjectTagsRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/tag/request/UpdateProjectTagsRequest";
import UpdateProjectTagsItem from "@/api/Main/dataSource/api/projects/task/i-service/models/tag/request/UpdateProjectTagsItem";

/**Сервис для управления тегами */
export class TaskTagsService implements ITaskParameters {
  /**Сервис для использования API */
  api = new ApiService();

  GetList(entityId: number): Promise<ResponseModel<TaskParameterModel[]>> {
    return new Promise<ResponseModel<TaskParameterModel[]>>(async (resolve) => {
      const result = new ResponseModel<TaskParameterModel[]>();

      await this.api.Main.TagGetService.getTagsByProjectIdAsync({
        ProjectsId: Array.isArray(entityId) ? entityId : [entityId],
      })
        .then((response) => {
          result.Value = response.Tags.map(
            (x) =>
              new TaskParameterModel({
                Id: x.Id,
                Color: x.Color,
                Name: x.TagName,
                IsDefault: false,
                InUse: x.InUse,
                Description: x.Description,
              }),
          );
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error("ERROR updateQueueTaskEmployeeRoleList", e);
          return resolve(result);
        });
    });
  }
  SetList(
    entityId: number,
    parameters: TaskParameterModel[],
  ): Promise<ResponseModel<TaskParameterModel[]>> {
    return new Promise<ResponseModel<TaskParameterModel[]>>(async (resolve) => {
      const result = new ResponseModel<TaskParameterModel[]>();

      await this.api.Main.TagSaveService.updateProjectTagsAsync(
        new UpdateProjectTagsRequest({
          ProjectId: entityId,
          Tags: parameters.map(
            (x) =>
              new UpdateProjectTagsItem({
                TagId: x.Id as number,
                Name: x.Name,
                Color: x.Color,
                Description: x.Description,
              }),
          ),
        }),
      )
        .then((response) => {
          result.Value = response.Items.map(
            (p) =>
              new TaskParameterModel({
                Id: p.Id,
                Name: p.TagName,
                Color: p.Color,
                InUse: p.InUse,
                Description: p.Description,
              }),
          );
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error("ERROR updateQueueTaskEmployeeRoleList", e);
          return resolve(result);
        });
    });
  }
}
